import { twx } from "../../library/utils/twx"

export const Box = twx.div`p-4 rounded-sm bg-white shadow-box`
